/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';

const Option = ({ option, index, selectedIndex, handleClickEvent }) => {
  const classNames = index === selectedIndex ? 'option-button-selected' : 'option-button';

  return (
    <div onClick={handleClickEvent} className={classNames}>
      {option.periodName}
    </div>
  );
};

Option.propTypes = {
  handleClickEvent: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  option: PropTypes.shape({
    periodName: PropTypes.string.isRequired,
  }).isRequired,
};

export default Option;
